import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Controller } from "../interface/controller.interface";
import { HTTPMethod } from "../model/http-method.enum";
import { HTTPRequestBuilder } from "../model/http.request.model";
import { HTTPService } from "./http.service";
import { orElse } from "../model/operator/or-else.operator";
import { CampaignProduct } from "../persistence/dto/campaign-product.model";

	/**
	 * @description
	 *  Servicio reflejo del controlador de zonas de campañas del backend.
	 *
	 * @see gigot-backend/Controllers/Products/CampaignProductController.cs
	 */

@Injectable({ providedIn: "root" })
export class CampaignProductService implements Controller {

	constructor(private httpService: HTTPService) {}

	public basePath(): string {
		return "api/campaign-products";
	}

	public computableProductsByCampaignId(campaignId: number): Observable<CampaignProduct[]> {
		return this.httpService.send<typeof undefined, CampaignProduct[]>(
			new HTTPRequestBuilder()
				.method(HTTPMethod.GET)
				.controllerPath(this.basePath())
				.relativePath(`computable/${campaignId}`)
				.build())
			.pipe(
				orElse<CampaignProduct[]>([] as CampaignProduct[]),
				map(campaignProducts => campaignProducts.map(campaignProduct => CampaignProduct.from(campaignProduct))));
	}

	public allByCampaignId(campaignId: number): Observable<CampaignProduct[]> {
		return this.httpService.send<typeof undefined, CampaignProduct[]>(
			new HTTPRequestBuilder()
				.method(HTTPMethod.GET)
				.controllerPath(this.basePath())
				.relativePath(`campaign/${campaignId}`)
				.build())
			.pipe(
				orElse<CampaignProduct[]>([] as CampaignProduct[]),
				map(campaignProducts => campaignProducts.map(campaignProduct => CampaignProduct.from(campaignProduct))));
	}

	public getForPaymentCycle(Id: number): Observable<CampaignProduct[]> {
		return this.httpService.send<typeof undefined, CampaignProduct[]>(
			new HTTPRequestBuilder()
				.method(HTTPMethod.GET)
				.controllerPath(this.basePath())
				.relativePath(`getforpaymentcycle/${Id}`)
				.build())
			.pipe(
				orElse<CampaignProduct[]>([] as CampaignProduct[]),
				map(campaignProducts => campaignProducts.map(campaignProduct => CampaignProduct.from(campaignProduct))));
	}
}
